import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const ShipOrderDialog = ({ shipFor, onClose, courier, setCourier, tracking, setTracking, busy, onSubmit }) => (
  <Dialog open={!!shipFor} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="order-ship-dialog">
      <DialogHeader><DialogTitle>Mark Shipped — {shipFor?.order_no}</DialogTitle></DialogHeader>
      <div className="space-y-3">
        <div><Label>Courier Name (optional)</Label><Input data-testid="order-ship-courier-input" value={courier} onChange={(e) => setCourier(e.target.value)} className="mt-1" placeholder="e.g. BlueDart" /></div>
        <div><Label>Tracking Number (optional)</Label><Input data-testid="order-ship-tracking-input" value={tracking} onChange={(e) => setTracking(e.target.value)} className="mt-1 font-mono" /></div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button data-testid="order-ship-submit" disabled={busy} onClick={onSubmit}>Mark Shipped</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
